import Cookie from 'js-cookie';

export default {
  auth(to, from, next) {
    if (!Cookie.get('token')) return next('/login');
    next();
  },

  unauthentic(to, from, next) {
    if (!Cookie.get('token')) return next('/login');
    next('/dashboard');
  },

  authCustom(to, from, next) {
    if (Cookie.get('token')) return next('/dashboard');
    next();
  },
};
